import { FC } from 'react';

import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';

import CarRentalAutoComplate, {
  CarRentalTypes,
} from '@domain/carRental/searchBar/home/carRentalAutoComplate';

import { Wrapper, StyledContent } from './styled';

export type AirportDataTypes = {
  label: string;
  onChange: (airport: CarRentalTypes) => void;
  isSubmited?: boolean;
  alignVertical?: boolean;
};

const CarRentalSelection: FC<AirportDataTypes> = ({
  label,
  onChange,
  isSubmited,
  alignVertical = false,
}) => {
  const screen = useBreakpoint();
  return (
    <StyledContent
      direction={screen.xs ? true : false}
      alignVertical={alignVertical}
    >
      <Wrapper alignVertical={alignVertical}>
        <CarRentalAutoComplate
          label={label}
          onChange={onChange}
          isSubmited={isSubmited}
          alignVertical={alignVertical}
        />
      </Wrapper>
    </StyledContent>
  );
};

export default CarRentalSelection;
